const START_TARIFF_BADGES: Record<number, string> = {
  1: 'В первый раз',
  2: 'Основной',
  3: 'После триала',
};

export function StartTariffBadge({ isStart }: { isStart: number | null }) {
  const label = START_TARIFF_BADGES[isStart ?? 0];
  if (!label) return null;
  return (
    <span className='inline-flex gap-2 text-xs px-1.5 py-0.5 rounded-md border border-primary/40 bg-primary/10 text-primary font-medium whitespace-nowrap'>
      <span>Стартовый</span> <span>{label}</span>
    </span>
  );
}
